<template>
    <div id="stepThreeForm" class="step-form">
        <p>Please check any of the items below that you'll need while filming.</p>
        <form>
            <label>
                Filming areas
                <span class="text-muted">(optional)</span>
            </label>
            <div class="row-fluid mb-3"> <!--for in-line display use "form-row" instead of "row-fluid"-->
                <CheckboxInput
                    inputId="FILMINTERIOR"
                    labelText="Interior"
                    v-model="FILMINTERIOR"
                    :optionalFlag="false"
                    :isRequired="false"
                    v-show="$attrs.formType == 'permit'"
                />
                <CheckboxInput
                    inputId="FILMEXT"
                    labelText="Exterior"
                    v-model="FILMEXT"
                    :optionalFlag="false"
                    :isRequired="false"
                    :disabled="$attrs.formType == 'grid'"
                />
                <CheckboxInput
                    inputId="FILMFRONT"
                    labelText="Front"
                    v-model="FILMFRONT"
                    :optionalFlag="false"
                    :isRequired="false"
                    v-show="$attrs.formType == 'permit'"
                />
                <CheckboxInput
                    inputId="FILMBACK"
                    labelText="Backyard"
                    v-model="FILMBACK"
                    :optionalFlag="false"
                    :isRequired="false"
                    v-show="$attrs.formType == 'permit'"
                />
                <CheckboxInput
                    inputId="FILMOTHER"
                    labelText="Other"
                    v-model="FILMOTHER"
                    :optionalFlag="false"
                    :isRequired="false"
                    v-show="$attrs.formType == 'permit'"
                />
                <small
                    class="form-text text-muted col-xs-12 col-sm-12"
                    v-if="$attrs.formType == 'grid'"
                >Grid permits are always exterior filming.</small>
                <small class="form-text text-muted col-xs-12 col-sm-12" v-else>Select all that apply</small>
            </div>
            <label v-show="$attrs.formType == 'permit'">
                Camera equipment on
                <span class="text-muted">(optional)</span>
            </label>
            <div class="row-fluid mb-3" v-show="$attrs.formType == 'permit'">
                <CheckboxInput
                    inputId="EQRW"
                    labelText="Road"
                    v-model="EQRW"
                    :optionalFlag="false"
                    :inline="true"
                    :isRequired="false"
                />
                <CheckboxInput
                    inputId="EQBLVD"
                    labelText="Boulevard"
                    v-model="EQBLVD"
                    :optionalFlag="false"
                    :inline="true"
                    :isRequired="false"
                />
                <CheckboxInput
                    inputId="EQSW"
                    labelText="Sidewalk"
                    v-model="EQSW"
                    :optionalFlag="false"
                    :inline="true"
                    :isRequired="false"
                />
                <small class="form-text text-muted col-xs-12 col-sm-12">Select all that apply</small>
            </div>
            <label>
                Camera in
                <span class="text-muted">(optional)</span>
            </label>
            <div class="row-fluid mb-3">
                <CheckboxInput
                    inputId="CAMCAR"
                    labelText="Car"
                    v-model="CAMCAR"
                    :optionalFlag="false"
                    :inline="true"
                    :isRequired="false"
                />
                <CheckboxInput
                    inputId="TOWRIG"
                    labelText="Tow rig"
                    v-model="TOWRIG"
                    :optionalFlag="false"
                    :inline="true"
                    :isRequired="false"
                />
                <small class="form-text text-muted col-xs-12 col-sm-12">Select all that apply</small>
            </div>
            <label v-show="$attrs.formType == 'permit'">
                Drone or UAV
                <span class="text-muted">(optional)</span>
            </label>
            <div class="row-fluid mb-3" v-show="$attrs.formType == 'permit'">
                <RadioInput
                    inputId="UAV"
                    v-model="UAV"
                    name="UAV"
                    labelText="Drone or UAV use"
                    :optionalFlag="false"
                    :isRequired="false"
                    :options="[{text:'Yes',value:'Y'},{text:'No',value:'N'}]"
                    :inline="false"
                />
            </div>
            <div class="form-row" v-show="$attrs.formType == 'permit'">
                <TextInput
                    inputId="VEHPULLLOC"
                    v-model="VEHPULLLOC"
                    labelText="Picture vehicle pull up / pull away / pass-by shots under
                        PDO supervision on location"
                    helpText="Please specify a location if applicable"
                    :isRequired="false"
                    :wrapperClasses="['col-md-8']"
                />
            </div>
            <div class="form-row">
                <TextInput
                    inputId="TRVSHOTLOC"
                    v-model="TRVSHOTLOC"
                    labelText="Travelling shot with normal traffic flow under PDO supervision on location"
                    :helpText="$attrs.formType == 'grid' ? 'Grid permits are always for CITY ALL. If you want a specific location, change your form type to permit in the top right corner.' : 'Please specify a location if applicable'"
                    :isRequired="$attrs.formType === 'grid'"
                    :wrapperClasses="['col-md-8']"
                    :disabled="$attrs.formType === 'grid'"
                />
            </div>
            <div class="form-row" v-show="$attrs.formType == 'permit'">
                <TextInput
                    inputId="POLSTOPLOC"
                    v-model="POLSTOPLOC"
                    labelText="Intermittent traffic stoppages (max. 3 minutes) under PDO supervision on location"
                    helpText="Please specify a location if applicable"
                    :isRequired="false"
                    :wrapperClasses="['col-md-8']"
                />
            </div>
            <div class="form-row" v-show="$attrs.formType == 'permit'">
                <TextAreaInput
                    inputId="SPFXDESC"
                    v-model="SPFXDESC"
                    labelText="Describe any special effects being used"
                    :isRequired="false"
                    :wrapperClasses="['col-md-8']"
                />
            </div>
            <div class="form-row">
                <TextAreaInput
                    inputId="SPECINSTR"
                    v-model="SPECINSTR"
                    labelText="Additional filming details ie. scene synopsis, additional filming needs, etc"
                    :isRequired="false"
                    :wrapperClasses="['col-md-8']"
                />
            </div>
        </form>
        <div
            class="alert alert-danger mt-3"
            v-if="_errorsExist() && submitted"
        >Please make sure you've filled all the fields out correctly.</div>
        <div class="d-flex justify-content-begin">
            <button id="previousStep" class="mt-3 mr-3 btn btn-secondary" @click="previousStep">Previous</button>
            <button id="nextStep" class="mt-3 btn btn-primary" @click="nextStep">Next</button>
        </div>
    </div>
</template>

<script>
import TextInput from "@/components/inputs/TextInput.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import TextAreaInput from "@/components/inputs/TextAreaInput.vue";
import RadioInput from "@/components/inputs/RadioInput.vue";

export default {
    name: "StepThreeForm",
    components: {
        TextInput,
        TextAreaInput,
        RadioInput,
        CheckboxInput
    },
    data() {
        return {
            step: 3,
            submitted: false
        };
    },
    computed: {
        formType() {
            return this.$store.getters.formType;
        },
        FILMINTERIOR: {
            get() {
                return this.$store.state.formData.FILMINTERIOR == "Y"
                    ? true
                    : false;
            },
            set(value) {
                if (value) {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "FILMINTERIOR",
                        data: "Y"
                    });
                } else {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "FILMINTERIOR",
                        data: "N"
                    });
                }
            }
        },
        FILMEXT: {
            get() {
                return this.$store.state.formData.FILMEXT == "Y" ? true : false;
            },
            set(value) {
                if (value) {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "FILMEXT",
                        data: "Y"
                    });
                } else {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "FILMEXT",
                        data: "N"
                    });
                }
            }
        },
        FILMFRONT: {
            get() {
                return this.$store.state.formData.FILMFRONT == "Y"
                    ? true
                    : false;
            },
            set(value) {
                if (value) {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "FILMFRONT",
                        data: "Y"
                    });
                } else {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "FILMFRONT",
                        data: "N"
                    });
                }
            }
        },
        FILMBACK: {
            get() {
                return this.$store.state.formData.FILMBACK == "Y"
                    ? true
                    : false;
            },
            set(value) {
                if (value) {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "FILMBACK",
                        data: "Y"
                    });
                } else {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "FILMBACK",
                        data: "N"
                    });
                }
            }
        },
        FILMOTHER: {
            get() {
                return this.$store.state.formData.FILMOTHER == "Y"
                    ? true
                    : false;
            },
            set(value) {
                if (value) {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "FILMOTHER",
                        data: "Y"
                    });
                } else {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "FILMOTHER",
                        data: "N"
                    });
                }
            }
        },
        EQRW: {
            get() {
                return this.$store.state.formData.EQRW == "Y" ? true : false;
            },
            set(value) {
                if (value) {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "EQRW",
                        data: "Y"
                    });
                } else {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "EQRW",
                        data: "N"
                    });
                }
            }
        },
        EQBLVD: {
            get() {
                return this.$store.state.formData.EQBLVD == "Y" ? true : false;
            },
            set(value) {
                if (value) {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "EQBLVD",
                        data: "Y"
                    });
                } else {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "EQBLVD",
                        data: "N"
                    });
                }
            }
        },
        EQSW: {
            get() {
                return this.$store.state.formData.EQSW == "Y" ? true : false;
            },
            set(value) {
                if (value) {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "EQSW",
                        data: "Y"
                    });
                } else {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "EQSW",
                        data: "N"
                    });
                }
            }
        },
        CAMCAR: {
            get() {
                return this.$store.state.formData.CAMCAR == "Y" ? true : false;
            },
            set(value) {
                if (value) {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "CAMCAR",
                        data: "Y"
                    });
                } else {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "CAMCAR",
                        data: "N"
                    });
                }
            }
        },
        TOWRIG: {
            get() {
                return this.$store.state.formData.TOWRIG == "Y" ? true : false;
            },
            set(value) {
                if (value) {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "TOWRIG",
                        data: "Y"
                    });
                } else {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "TOWRIG",
                        data: "N"
                    });
                }
            }
        },
        VEHPULLLOC: {
            get() {
                return this.$store.state.formData.VEHPULLLOC;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "VEHPULLUP",
                    data: value ? "Y" : "N"
                });
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "VEHPULLLOC",
                    data: value
                });
            }
        },
        TRVSHOTLOC: {
            get() {
                return this.$store.state.formData.TRVSHOTLOC;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "TRAVSHOOT",
                    data: value ? "Y" : "N"
                });
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "TRVSHOTLOC",
                    data: value
                });
            }
        },
        POLSTOPLOC: {
            get() {
                return this.$store.state.formData.POLSTOPLOC;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "TRAFSTOP",
                    data: value ? "Y" : "N"
                });
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "POLSTOPLOC",
                    data: value
                });
            }
        },
        SPFXDESC: {
            get() {
                return this.$store.state.formData.SPFXDESC;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "FX",
                    data: value ? "Y" : "N"
                });
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "SPFXDESC",
                    data: value
                });
            }
        },
        UAV: {
            get() {
                return this.$store.state.formData.UAV;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "UAV",
                    data: value
                });
            }
        },
        SPECINSTR: {
            get() {
                return this.$store.state.formData.SPECINSTR;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "SPECINSTR",
                    data: value
                });
            }
        }
    },
    methods: {
        nextStep() {
            this.submitted = true;

            if (!this._errorsExist()) {
                this.$store.dispatch("COMPLETE_STEP", {
                    step: this.step,
                    complete: true
                });
            }
        },
        previousStep() { 
                this.$store.dispatch('SET_STEP', this.step - 1);        
        },
    }
};
</script>
